/* src/app/forms/demo-acoes/demo-acoes.component.scss */
.demo-wrapper {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
}
.demo-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.demo-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
  color: #1976d2;
}
.demo-header-text {
  flex: 1;
}
.demo-title {
  margin: 0;
  font-size: 22px;
  font-weight: 500;
}
.demo-subtitle {
  margin: 4px 0 0;
  color: #666;
  font-size: 13px;
}
.selection-badge {
  background: #1976d2;
  color: #fff;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}
.config-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}
@media (max-width: 960px) {
  .config-row {
    grid-template-columns: 1fr;
  }
}
.config-card {
  border-top: 4px solid transparent;
}
.config-card.config-fn {
  border-top-color: #1976d2;
}
.config-card.config-c {
  border-top-color: #f57c00;
}
.config-card.config-nm {
  border-top-color: #7b1fa2;
}
.type-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: #fff;
}
.type-avatar.fn {
  background: #1976d2;
}
.type-avatar.c {
  background: #f57c00;
}
.type-avatar.nm {
  background: #7b1fa2;
}
.full-width {
  width: 100%;
}
.field-row {
  display: flex;
  gap: 8px;
}
.field-row mat-form-field {
  flex: 1;
}
.btn-nm {
  background: #7b1fa2 !important;
  color: #fff !important;
}
.table-card {
  overflow: hidden;
}
.demo-table {
  width: 100%;
}
.demo-table .mat-column-select {
  width: 52px;
}
.demo-table .mat-header-cell {
  background: #fafafa;
  font-weight: 600;
}
tr.mat-row {
  cursor: pointer;
}
tr.mat-row:hover {
  background: #f5f5f5;
}
tr.selected-row {
  background: #e3f2fd;
}
tr.selected-row:hover {
  background: #bbdefb;
}
.marketplace-badge {
  padding: 3px 10px;
  border-radius: 12px;
  background: #ede7f6;
  color: #4527a0;
  font-size: 12px;
}
.status-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}
.status-badge.status-pendente {
  background: #fff3e0;
  color: #e65100;
}
.status-badge.status-pago {
  background: #e8f5e9;
  color: #2e7d32;
}
.status-badge.status-enviado {
  background: #e3f2fd;
  color: #1565c0;
}
.status-badge.status-entregue {
  background: #f3e5f5;
  color: #6a1b9a;
}
.status-badge.status-cancelado {
  background: #fce4ec;
  color: #c62828;
}
/*# sourceMappingURL=demo-acoes.component.css.map */
